<p-progressSpinner *ngIf="busyCombos" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>

<div class="container-novopedido flex flex-column inputs-uppercase" *ngIf="!busyCombos">
    <div class="card flex flex-column justify-content-center align-items-center">
        <h3>{{tituloPedidoSelecionado}}</h3>
    </div>

    <div class="card card-lab">
        <div class="flex flex-row gap-1 mt-2 mb-2" style="justify-content: right;">
            <p-button class="btn-bg-primary" label="Fechar OS" (click)="limpar()" [disabled]="modalCadastrarCliente"></p-button>
        </div>
        <p-fieldset class="no-legend" legend="">
            <div> <h4>Loja</h4> </div>
            <div class="formgrid grid m-0">
                <div class="field col-12">
                    <div class="mr-2">
                        <p-dropdown [title]="tituloLojaBloqueada" [disabled]="lojaBloqueada"
                            class="p-inputtext-sm"  emptyMessage="Nenhuma loja encontrado" [options]="lojas" 
                            [(ngModel)]="laboratorioSelecionado" 
                            placeholder="Selecione uma loja" optionLabel="nome_fantasia" [showClear]="true"
                            [virtualScroll]='!!lojas && lojas.length > 38' [virtualScrollItemSize]="38" [style]="{width:'100%'}">
                            <ng-template pTemplate="selectedItem">
                                <div  class="flex align-items-center gap-2"  *ngIf="laboratorioSelecionado">
                                    <div>{{ laboratorioSelecionado?.nome_fantasia }} - {{ laboratorioSelecionado?.cnpj ?? '' | cpfCnpj }}</div>
                                </div>
                            </ng-template>

                            <ng-template let-lab pTemplate="item">
                                <div  class="flex align-items-center gap-2 text-sm">
                                    <div>{{ lab?.nome_fantasia }} - {{ lab?.cnpj ?? '' | cpfCnpj }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown> 
                    </div>
                </div>
            </div>
        </p-fieldset> 
    </div>

    <div class="card" *ngIf="laboratorioSelecionado">
        <p-fieldset class="no-legend" legend="">
            <h4>Cliente</h4>
            <div class="formgrid grid m-0">
                <div class="field col-12 mb-4">
                    <div class="mr-2">
                        <app-table-select
                            [(ngModel)]="lojaSelecionada"
                            [suggestions]="clientes"
                            [columns]="colunasClientes"
                            optionLabel="nome_completo"
                            (completeMethod)="buscarClientes($event)"
                            [disabled]="carregadoComboProduto"
                            [loading]="loadingClientes"
                            [delay]="500"
                            placeholder="Pesquise um cliente..."
                            searchPlaceholder="Buscar por Nome ou CPF..."
                            dialogHeader="Selecionar Cliente"
                            emptyMessage="Nenhum cliente encontrado"
                            [showClear]="true"
                            [style]="{'width':'100%'}">
                        </app-table-select>
                        <div class="flex flex-row gap-1 mt-2">
                            <p-button class="btn-bg-primary" label="Novo" (click)="novoCliente()"></p-button>
                            <p-button class="btn-bg-primary" label="Alterar" (click)="alterarCliente(lojaSelecionada?.id)" [disabled]="!lojaSelecionada || !lojaSelecionada.id"></p-button>
                        </div>
                    </div>
                </div>
                <div class="field col-12 mb-3">
                    <label>Marketing</label>
                    <p-dropdown
                        class="p-inputtext-sm"
                        [options]="listagemMarketing"
                        [(ngModel)]="marketingSelecionado"
                        optionLabel="mk_descricao"
                        [showClear]="true"
                        placeholder="Selecione o marketing"
                        emptyMessage="Nenhum registro encontrado"
                        [style]="{'width':'100%'}">
                    </p-dropdown>
                </div>
                <div class="field col-12 md:col-6 lg:col-6" *ngIf="opcaoPedidoSelecionado === 'pedido_venda'">
                    <label>Previsão Entrega</label>
                    <p-calendar [(ngModel)]="dadosForm.DtPrevisaoEntrega" dateFormat="dd/mm/yy" [showIcon]="true" [minDate]="maxDate" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm text-sm p-datepicker-sm'"></p-calendar>
                </div>
            </div>
        </p-fieldset>
    </div>

    <p-progressSpinner *ngIf="busyComboProduto" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>

    <div *ngIf="laboratorioSelecionado">
        <app-ordem-de-servico #ordemServicoComponent *ngIf="opcaoPedidoSelecionado === 'pedido_lab'" [dadosForm]="dadosForm" [comboOutrosServicos]="comboOutrosServicos" [servicosAdicionados]="produtosAdicionados" [produtosLentes]="produtosLentes" (NumeroOSChange)="checarOSNumero($event)" [laboratorioSelecionado]="laboratorioSelecionado" [os_numero_readonly]="os_numero_readonly" [anexosExistentes]="anexosExistentes" (removerAnexoExistente)="removerAnexoExistente($event)"></app-ordem-de-servico>
        <app-pedido-venda #pedidoVendaComponent *ngIf="opcaoPedidoSelecionado === 'pedido_venda'" [dadosForm]="dadosForm" [comboOutrosServicos]="produtos" [servicosAdicionados]="produtosAdicionados" [laboratorioSelecionado]="laboratorioSelecionado" [os_numero_readonly]="os_numero_readonly" [anexosExistentes]="anexosExistentes" (NumeroOSChange)="checarOSNumero($event)" (removerAnexoExistente)="removerAnexoExistente($event)"></app-pedido-venda>

        <div class="card card-resumo">
            <p-fieldset class="no-legend" legend="">
                <h4>Resumo do pedido</h4>
                 <div class="formgrid grid m-0">
                   <div class="field col-12 md:col-12 xl:col-12">
                        <p-table [value]="produtosAdicionados" styleClass="p-datatable-striped">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Código</th>
                                    <th>Item</th>
                                    <th>Qtd</th>
                                    <th>Olho</th>
                                    <th>Valor</th>
                                    <th>Desconto</th>
                                    <th>Total</th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-produto let-index="rowIndex">
                                <tr>
                                    <td>{{ produto.codigo }}</td>
                                    <td>{{ produto.descricao }}</td>
                                    <td>{{ produto.quantidadeAdd }}</td>
                                    <td>{{ produto.tipo_prod }}</td>
                                    <td>{{ produto.vlr_venda_tratado | currency: 'BRL'}}</td>
                                    <td>{{ produto.desc_acresc_porcentagem ?? 0 }}%</td>
                                    <td>{{ produto.vlr_liquido_produto * produto.quantidadeAdd | currency: 'BRL' }}</td>
                                    <td><p-button icon="pi pi-times-circle" [rounded]="true" [text]="true" severity="danger" (click)="deletarServico(produto, index);"></p-button></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div> 
                    <div class="formgrid grid w-full">
                        <div class="field resumo-pedido-totais flex flex-column col-12 xl:col-8 xl:col-offset-4"><!---->
                            <div class="total-item">
                                <p class="col-6 titulo">Qtde de itens</p>
                                <p class="col-3 valor"> {{produtosAdicionados?.length ?? 0}}</p>
                            </div>
                            <div class="total-item">
                                <p class="col-6 titulo">Desconto total</p>
                                <p class="col-3 valor">{{ descontoTotal() | currency: 'BRL' }}</p>
                            </div>
                            <div class="total-item">
                                <p class="col-6 titulo">Valor total</p>
                                <p class="col-3 valor">{{ valorTotal() | currency: 'BRL' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <p-fieldset class="" legend="Observação" *ngIf="opcaoPedidoSelecionado === 'pedido_lab'">
            <div class="p-fluid formgrid m-0 grid">
                <div class="field col">
                    <textarea rows="2" cols="30" pInputTextarea [autoResize]="true" [(ngModel)]="dadosForm.observacao"></textarea>
                </div>
            </div>
        </p-fieldset>

        <div class="card card-acoes">
            <p-button label="Salvar" icon="pi pi-plus" (click)="confirmCadastrarPedido()" [disabled]="pedidoValido() === false || pedidoAprovado" [loading]="loadingSave"></p-button>
        </div>
    </div>

</div>

<div class="card flex justify-content-center inputs-uppercase">
    <p-confirmDialog #conf [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                <i class="pi pi-question text-5xl"></i>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton *ngIf="confirmBtnNaoVisible" label="Não" (click)="conf.reject()"></button>
            <button type="button" pButton label="Sim" (click)="conf.accept()"></button>
        </ng-template>
    </p-confirmDialog>
</div>

<p-dialog header="Header" [(visible)]="modalCadastrarPedido" class="width-modal inputs-uppercase" (onHide)="fecharModalRespostaCadastrarPedido()">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">{{lblModalSalvarPedido}}</span>
        </div>
    </ng-template>

    <p-progressSpinner *ngIf="loadingSave" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>

    <div *ngIf="!loadingSave">
        <p class="m-0">
            {{textoCadastrarNovoPedido}} <strong *ngIf="pedidoCadastrado">OS-{{pedidoCadastrado}}</strong>
        </p>
    </div>
    <ng-template pTemplate="footer">
        <!-- <p-button icon="pi pi-file-pdf" severity="info" [disabled]="loadingSave || !pdfLiberado" (click)="solicitarPDF(opcaoPedidoSelecionado)" label="Baixar PDF" ></p-button> -->

        <p-button icon="pi pi-check" (click)="modalCadastrarPedido = false" label="Fechar" pAutoFocus [disabled]="loadingSave"></p-button>
    </ng-template>

</p-dialog>

<p-dialog header="Header" [(visible)]="modalCadastrarCliente" class="width-modal inputs-uppercase" (onHide)="fecharModalRespostaCadastrarCliente()" width="400px" [closable]="!loadingCliente">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">{{lblModalSalvarCliente}}</span>
        </div>
    </ng-template>

    <p-progressSpinner *ngIf="loadingCliente" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>
    <div *ngIf="!loadingCliente">
        <p-fieldset class="title-legend" legend="Cadastro de Cliente" [style]="{'margin-bottom': '.5rem'}">
            <div class="formgrid grid m-0 p-fluid">
                <!-- Tipo -->
                <div class="field col-12 lg:col-2 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['tipo_cliente']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['tipo_cliente']?.rotulo || 'Tipo' }} <span *ngIf="clienteCamposConfiguracao.campo['tipo_cliente']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-dropdown 
                        [disabled]="true"
                        [(ngModel)]="dadosCliente.tipo_cliente"
                        [options]="listagemTiposCliente"
                        optionLabel="descricao"
                        optionValue="id"
                        [styleClass]="'p-inputtext-sm w-full'">
                    </p-dropdown>
                </div>
                
                <!-- Pessoa -->
                <div class="field col-12 lg:col-2 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['pessoa']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['pessoa']?.rotulo || 'Pessoa' }} <span *ngIf="clienteCamposConfiguracao.campo['pessoa']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-dropdown 
                        [disabled]="true"
                        [(ngModel)]="dadosCliente.pessoa"
                        [options]="listagemPessoaPessoa"
                        optionLabel="label"
                        optionValue="value"
                        [styleClass]="'p-inputtext-sm w-full'">
                    </p-dropdown>
                </div>

                <!-- CPF -->
                <div class="field col-12 lg:col-2 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['cpf']?.exibir == 'S' && dadosCliente.pessoa == 'F' ">
                    <label>{{ clienteCamposConfiguracao.campo['cpf']?.rotulo || 'CPF' }} <span *ngIf="clienteCamposConfiguracao.campo['cpf']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-inputMask class="p-inputtext-sm" mask="999.999.999-99" [(ngModel)]="dadosCliente.cpf" />
                </div>

                <!-- CNPJ -->
                <div class="field col-12 lg:col-2 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['cnpj']?.exibir == 'S' && dadosCliente.pessoa == 'J'">
                    <label>{{ clienteCamposConfiguracao.campo['cnpj']?.rotulo || 'CNPJ' }} <span *ngIf="clienteCamposConfiguracao.campo['cnpj']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-inputMask class="p-inputtext-sm" mask="99.999.999/9999-99" [(ngModel)]="dadosCliente.cnpj" />
                </div>

                <!-- Gênero -->
                <div class="field col-12 lg:col-3 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['genero']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['genero']?.rotulo || 'Gênero' }} <span *ngIf="clienteCamposConfiguracao.campo['genero']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-dropdown 
                        [(ngModel)]="dadosCliente.genero"
                        [options]="listagemGeneroPessoa"
                        optionLabel="descricao"
                        optionValue="id"
                        [styleClass]="'p-inputtext-sm w-full'">
                    </p-dropdown>
                </div>      

                <!-- Profissão -->
                <div class="field col-12 lg:col-3 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['profissao']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['profissao']?.rotulo || 'Profissão' }} <span *ngIf="clienteCamposConfiguracao.campo['profissao']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-dropdown 
                        [(ngModel)]="dadosCliente.profissao"
                        [options]="listagemProfissoes"
                        optionLabel="descricao"
                        optionValue="id"
                        [styleClass]="'p-inputtext-sm w-full'">
                    </p-dropdown>
                </div>      

                <!-- Nome Completo -->
                <div class="field col-12 lg:col-6 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['nome_completo']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['nome_completo']?.rotulo || 'Nome Completo' }} <span *ngIf="clienteCamposConfiguracao.campo['nome_completo']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <input [(ngModel)]="dadosCliente.nome_completo" pInputText type="text" class="inputP">
                </div>      

                <!-- Nome Social -->
                <div class="field col-12 lg:col-3 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['nome_social']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['nome_social']?.rotulo || 'Nome Social' }} <span *ngIf="clienteCamposConfiguracao.campo['nome_social']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <input [(ngModel)]="dadosCliente.nome_social" pInputText type="text" class="inputP">
                </div>      

                <!-- Apelido -->
                <div class="field col-12 lg:col-3 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['apelido']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['apelido']?.rotulo || 'Apelido' }} <span *ngIf="clienteCamposConfiguracao.campo['apelido']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <input [(ngModel)]="dadosCliente.apelido" pInputText type="text" class="inputP">
                </div>      

                <!-- Data Nascimento -->
                <div class="field col-12 lg:col-3 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['data_nascimento']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['data_nascimento']?.rotulo || 'Data de Nascimento' }} <span *ngIf="clienteCamposConfiguracao.campo['data_nascimento']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-calendar [showButtonBar]="true" [(ngModel)]="dadosCliente.data_nascimento" (onInput)="maskDate($event)" dateFormat="dd/mm/yy" [styleClass]="'w-full p-inputtext-sm'" appendTo="body"></p-calendar>
                </div>      

                <!-- Celular -->
                <div class="field col-12 lg:col-3 mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['celular']?.exibir == 'S'">
                    <label>{{ clienteCamposConfiguracao.campo['celular']?.rotulo || 'Celular' }} <span *ngIf="clienteCamposConfiguracao.campo['celular']?.obrigatorio == 'S'" style="color: red;">*</span></label>
                    <p-inputMask class="p-inputtext-sm" mask="(99) 9 9999-9999" [(ngModel)]="dadosCliente.celular" />
                </div>      

                <!-- Tem filhos -->
                <div class="field col-12 lg:col-3 flex align-items-center mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['tem_filhos']?.exibir == 'S'">
                    <p-checkbox [(ngModel)]="dadosCliente.tem_filhos" [binary]="true" [label]="clienteCamposConfiguracao.campo['tem_filhos']?.rotulo || 'Tem filhos'"></p-checkbox>
                </div>

                <!-- Optante simples nacional -->
                <!-- <div class="field col-12 lg:col-3 flex align-items-center mb-2" *ngIf="clienteCamposConfiguracao && clienteCamposConfiguracao.campo['optante_simples_nacional']?.exibir == 'S'">
                    <p-checkbox [(ngModel)]="dadosCliente.optante_simples_nacional" [binary]="true" [label]="clienteCamposConfiguracao.campo['optante_simples_nacional']?.rotulo || 'Optante Simples Nacional'"></p-checkbox>
                </div> -->
            </div>      

            <!-- ENDEREÇO -->
             <div class="formgrid grid m-0 p-fluid mt-4">     
                <!-- CEP -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>CEP</label>
                    <p-inputMask class="p-inputtext-sm" mask="99999-999" [(ngModel)]="dadosCliente.endereco.cep" (onComplete)="buscarEndereco()" />
                </div>      
                <!-- Logradouro -->
                <div class="field col-12 lg:col-6 mb-2">
                    <label>Logradouro</label>
                    <input [disabled]="enderecoClienteLoading" [(ngModel)]="dadosCliente.endereco.logradouro" pInputText type="text"  class="inputP">
                </div>      
                <!-- Número -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Número</label>
                    <input [(ngModel)]="dadosCliente.endereco.numero" pInputText type="text"  class="inputP">
                </div>      
                <!-- Complemento -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Complemento</label>
                    <input [disabled]="enderecoClienteLoading" [(ngModel)]="dadosCliente.endereco.complemento" pInputText type="text"   class="inputP">
                </div>      
                <!-- Bairro -->
                <div class="field col-12 lg:col-4 mb-2">
                    <label>Bairro</label>
                    <input [disabled]="enderecoClienteLoading" [(ngModel)]="dadosCliente.endereco.bairro" maxlength="30" pInputText type="text" class="inputP">
                </div>      
                <!-- Cidade -->
                <div class="field col-12 lg:col-4 mb-2">
                    <label>Cidade</label>
                    <p-autoComplete
                        [disabled]="enderecoClienteLoading"
                        class="p-inputtext-sm"
                        [(ngModel)]="dadosCliente.endereco.cod_cidade"
                        [suggestions]="listagemCidades"
                        optionLabel="nome"
                        (completeMethod)="buscarCidades($event)"
                        placeholder="Pesquise uma cidade..."
                        [showClear]="true"
                        [virtualScroll]="!!listagemCidades && listagemCidades.length > 38"
                        [virtualScrollItemSize]="38"
                        [style]="{'width':'100%'}"
                        [inputStyle]="{'width':'100%'}"
                        [styleClass]="'text-sm'"
                        [showEmptyMessage]="true"
                        emptyMessage="Nenhuma cidade encontrada">
                        <ng-template let-cidade pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="cidade">
                                <div>
                                    {{ cidade.nome }}
                                </div>
                            </div>
                        </ng-template>
                    
                        <ng-template let-cidade pTemplate="item">
                            <div class="flex align-items-center gap-2" *ngIf="cidade">
                                <div>
                                    {{ cidade.nome }}
                                </div>
                            </div>
                        </ng-template>
                    </p-autoComplete>
                </div>      

                <!-- Email -->
                <div class="field col-12 lg:col-4 mb-2">
                    <label>E-mail</label>
                    <input class="p-inputtext-sm" style="text-transform: unset !important;" pInputText type="text" [(ngModel)]="dadosCliente.email" placeholder="ex: contato@email.com" />
                </div>      
            </div>
        </p-fieldset>
        <br>
        <br>
        <br>
        <br>
        <br>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="salvarCliente()" label="Salvar" pAutoFocus [disabled]="loadingCliente"></p-button>
        <p-button icon="pi pi-times" (click)="modalCadastrarCliente = false" label="Fechar" pAutoFocus [disabled]="loadingCliente"></p-button>
    </ng-template>
</p-dialog>
